import {
  pipelineColumnOptions,
  pipelineDefaultColumnVisibilityModel,
  pipelineDefaultSortDirection,
  pipelineDefaultSortKey,
  pipelineQuickSortOptions,
  type PipelineSortDirection,
  type PipelineSortKey,
  type PipelineTableStatus,
  pipelineSortOptions,
  pipelineStatusOptions,
} from '@/features/pipelines/pages/pipelinesTableDefinition';
import { TableToolbar } from '@/features/shared/components/tableSystem/TableToolbar';
import type { DateQuickFilter } from '@/features/shared/hooks/useDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type PipelinesTableToolbarProps = {
  searchValue: string;
  onDebouncedSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: PipelineSortKey;
  sortDirection: PipelineSortDirection;
  onSortChange: (sortKey: PipelineSortKey, sortDirection: PipelineSortDirection) => void;
  filterStatuses: PipelineTableStatus[];
  onFilterStatusesChange: (next: PipelineTableStatus[]) => void;
  filterEntities?: string[];
  onFilterEntitiesChange?: (next: string[]) => void;
  entityOptions?: Array<{ value: string; label: string }>;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  filterProjects?: string[];
  onFilterProjectsChange?: (next: string[]) => void;
  projectOptions?: Array<{ value: string; label: string }>;
  dateQuickFilter: DateQuickFilter;
  onDateQuickFilterChange: (next: DateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  latestQueryStartDay?: string | null;
  latestQueryEndDay?: string | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
  summaryCount?: number | null;
};

export const PipelinesTableToolbar = (props: PipelinesTableToolbarProps): ReactElement => (
  <TableToolbar<PipelineSortKey, PipelineTableStatus>
    title={undefined}
    searchAriaLabel="Search pipelines, tags"
    includeLatestQuickFilter
    defaultColumnVisibilityModel={pipelineDefaultColumnVisibilityModel}
    columnOptions={pipelineColumnOptions}
    defaultSortKey={pipelineDefaultSortKey}
    defaultSortDirection={pipelineDefaultSortDirection}
    sortOptions={pipelineSortOptions}
    quickSortOptions={pipelineQuickSortOptions}
    statusOptions={pipelineStatusOptions}
    summarySingularLabel="pipeline"
    summaryPluralLabel="pipelines"
    entityLabel="Pipeline"
    hideDateRangeLabel
    showControlsWithoutSummary
    {...props}
  />
);

export type { DateQuickFilter };
